import type { FetcherAxiosInstance } from '../fetcher';

export const createQuestionsApi = (Fetcher: FetcherAxiosInstance) => ({
  getProductQuestions({
    productId, sort, limit = 2, page = 1,
  }) {
    return Fetcher(`/questions/${productId}`, {
      params: {
        page,
        limit,
        sort,
      },
    });
  },

  sendQuestion({ productId, question }) {
    return Fetcher.post(`/questions/${productId}`, { body: question });
  },

  getProductQuestionsCount({ productId }) {
    return Fetcher(`/questions-count/${productId}`);
  },
});
